<template>
  <div class="modal-email">
    <div class="modal-header">
      <h3 class="title">Dodajte dokumenta</h3>
    </div>
    <div class="content">
      <div class="upload-area">
        <upload-button
          class="upload-btn"
          @files-selected="getFiles"
          ref="uploadBtn"
        ></upload-button>
        <div class="uploaded">
          <div v-if="attachments.length == 0" class="no-files">
            <div class="upload-wrapper" @click="addFile">
              <svg
                class="upload-icon pointer-cursor"
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="33"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <label class="upload-text pointer-cursor"
                >Izaberite datoteku</label
              >
            </div>
          </div>
          <div v-else>
            <div class="file" v-for="(file, index) of attachments" :key="index">
              <p>{{ file.name }}</p>
              <i
                class="fas fa-times del--mod"
                @click="removeUploadedFile(index)"
              ></i>
            </div>
            <div
              class="email-upload-more-wrapper pointer-cursor"
              @click="addMoreFiles"
            >
              <svg
                class
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 50 43"
              >
                <path
                  d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                />
              </svg>
              <span class>Dodaj datoteku</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <transition enter-active-class="animated shake">
        <div v-if="errorMsg.length > 0" class="error">{{ errorMsg }}</div>
      </transition>
      <button type="submit" class="btn btn-danger" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="addDocuments"
        :disabled="isLoading"
      >
        <div v-if="!isLoading">Pošalji</div>
        <div v-else>
          <spinner size="20" line-fg-color="#00796b" class="spinner"></spinner>
        </div>
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from '@/axios/axios.js';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';
export default {
  name: 'EmailModal',
  components: {
    uploadButton
  },
  data() {
    return {
      attachments: [],
      isLoading: false,
      errorMsg: ''
    };
  },
  computed: {
    ...mapState('modal', ['manager'])
  },
  methods: {
    ...mapMutations('modal', ['closeModal', 'setManager', 'setUserDocuments']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getInfrastructureById']),
    getFiles(load) {
      for (const l of load) {
        this.attachments.push(l);
      }
    },
    addFile() {
      if (this.attachments.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
      return;
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.attachments.splice(index, 1);
    },
    async addDocuments() {
      this.errorMsg = '';
      if (this.attachments.length == 0) {
        this.errorMsg = 'Morate dodati bar jedan dokument';
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      axios
        .post('/media/add', this.formatMediaForSubmit(), {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(data => {
          this.addDocumentsForUser(data);
        })
        .catch(error => {
          this.isLoading = false;
          console.log(error);
          this.showFailModal();
        });
    },
    async addDocumentsForUser(mediaData) {
      try {
        const data = {
          mediaIds: mediaData.data.ids
        };
        console.log(this.manager);
        console.log(this.manager.user);
        await axios.post(`user/${this.manager.user.id}/user-document`, data);
        const userDocuments = await this.getUserDocuments();
        this.manager.documents = userDocuments;
        this.setManager(this.manager);
        console.log('iz modala', userDocuments);
        this.setUserDocuments(userDocuments);
        this.showSuccessModal();
        this.closeModal();
      } catch (error) {
        console.log(error);
        this.showFailModal();
      }
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.attachments.length; i++) {
        fd.append('files[]', this.attachments[i], this.attachments[i].name);
      }
      fd.append('type', 'community');
      fd.append(
        'community_id',
        this.$store.getters.getActiveCommunity.community_id
      );

      return fd;
    },
    async getUserDocuments() {
      try {
        const result = await axios.get(
          `user/${this.manager.user.id}/user-document`
        );
        return result.data.data;
      } catch (error) {
        throw error;
      }
    },
    validateInput() {
      return (
        !this.isEmpty(this.emailSubject, 'Naslov je obavezan') &&
        !this.isEmpty(this.selectedCommunity, 'Morate izabrati zajednicu')
      );
    },
    getSelectedEmails() {
      const emails = [];
      for (let member of this.getSelectedMembers) {
        emails.push(member.email);
      }
      return emails;
    },
    isEmpty(element, errorMsg) {
      let isEmpty = false;
      if (Array.isArray(element)) {
        isEmpty = element.length == 0;
      } else if (typeof element == 'string') {
        isEmpty = element == '';
      } else {
        throw new Error(
          '[isEmpty] Unsupported type. Array or string are expected'
        );
      }
      if (isEmpty) {
        this.errorMsg = errorMsg;
      }
      return isEmpty;
    }
  },
  directives: {
    'click-outside': {
      priority: 700,
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = event => {
          if (
            !(
              el == event.target ||
              el.contains(event.target) ||
              vnode.context.$refs.dropdown.contains(event.target)
            )
          ) {
            vnode.context[binding.expression]();
          }
        };

        el.handleEscapeKey = event => {
          if (event.key === 'Escape') {
            vnode.context[binding.expression]();
          }
        };

        document.body.addEventListener('click', el.clickOutsideEvent);
        document.body.addEventListener('touchstart', el.clickOutsideEvent);
        document.body.addEventListener('keyup', el.handleEscapeKey);
      },
      unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
        document.body.removeEventListener('touchstart', el.clickOutsideEvent);
        document.body.addEventListener('keyup', el.handleEscapeKey);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-email {
  .modal-header {
    width: fit-content;
    .to h3 {
      color: rgb(46, 45, 45);
    }
  }

  .title {
    margin-right: 8px;
    color: rgb(46, 45, 45);
  }

  .content {
    padding: 1.5rem 0;
    .margin-bottom-1 {
      margin-bottom: 1rem;
    }
    .to {
      margin-bottom: 1.5rem;
      position: relative;

      .to-wrapper {
        border: 1px solid #ced4da;
        border-radius: 4px;
        min-height: 38px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 5px;
        .no-emails {
          color: rgb(88, 88, 88);
        }
        .email-bubble {
          display: inline-flex;
          align-items: center;
          padding: 2px 8px;
          border-radius: 40px;
          border: 1px solid var(--primary-color);
          font-weight: 900;
          font-size: 12px;
          z-index: 5;
          max-height: 24px;
          color: rgb(88, 88, 88);
          margin: 4px 0;
          .bubble-x {
            padding-left: 5px;
          }
          .bubble-x:hover {
            color: black;
            cursor: pointer;
          }
        }

        .email-bubble:hover {
          cursor: default;
        }

        .email-bubble:not(:first-of-type) {
          margin-left: 5px;
        }
      }

      .to-wrapper {
        cursor: text;
      }

      .dropdown {
        position: absolute;
        border-radius: 4px;
        border: 1px solid #ced4da;
        background-color: white;
        min-width: 60%;
        max-width: 100%;
        // box-shadow: 0 1px 2px 2px rgba(60, 64, 67, 0.149);
        .input-wrapper {
          position: relative;
          .to-input {
            border: none;
            border-radius: 0;
            width: 100%;
            background-color: #f5f5f54d;
          }

          .to-input:focus {
            box-shadow: none;
          }

          .btn--dropdown {
            position: absolute;
            top: 3px;
            right: 10px;
            font-size: 12px;
            width: 80px;
            height: 30px;
            text-align: center;
            background-color: transparent;
          }

          .btn--dropdown:focus,
          .btn--dropdown:active {
            outline: none;
            box-shadow: none;
          }

          .btn--select {
            border: 1px solid var(--primary-color);
            color: black;
          }

          .btn--select:hover {
            background-color: var(--primary-color);
            color: white;
          }
        }

        .members-wrapper {
          max-height: 190px;
          overflow-y: auto;

          .member {
            padding: 5px 5px;
            display: flex;
            justify-content: space-between;
            position: relative;
            .basic {
              display: flex;
              flex-direction: column;
              .email {
                font-size: 15px;
                color: #5e5e5e;
              }
            }

            .empty-space {
              width: 50px;
            }

            .description {
              display: flex;
              flex-direction: column;
              position: relative;
              // align-items: flex-end;
              .desc {
                color: #424242;
                font-size: 16px;
              }
            }
            .desc-cb {
              position: absolute;
              bottom: 25px;
              right: 20px;
              padding-left: 0;
              margin-bottom: 0;
            }
          }

          .empty-list {
            height: 35px;
            padding: 5px;
          }
        }

        .member:hover {
          background-color: #ececec;
          cursor: pointer;
        }
      }
    }

    .upload-area {
      margin-top: 5px;
      padding: 5px 0;
      width: 100%;
      text-align: center;

      .no-files {
        padding: 0 5px;
      }
      .uploaded {
        background-color: rgb(241, 241, 241);
        border-radius: 4px;
      }
      .file {
        font-size: 15px;
        width: 100%;
        display: inline-flex;
        align-items: center;
        padding: 0 5px;
        p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          padding-right: 8px;
          margin-bottom: 2px;
        }

        .del--mod {
          margin-left: auto;

          cursor: pointer;
          color: red;
        }
      }

      .file:not(:last-of-type) {
        border-bottom: solid 1px lightgray;
      }
    }
  }

  .modal-footer {
    padding: 1rem 0;

    .error {
      margin-right: auto;
      color: red;
    }

    .btn--mod {
      min-width: 71px;
      min-height: 38px;
    }
  }
}
</style>
